import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'user-contact-management',
    templateUrl: './user-contact-management.component.html',
    styleUrls: ['./user-contact-management.component.scss']
})
export class UserContactManagementComponent implements OnInit {

    userContactForm: FormGroup;
    @Input() countries: any;
    @Output() emitUserContactForm: EventEmitter<any> = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit(): void {
        this.populateUserContactForm();
    }

    emitUserContactFormValue() {
        const userContact = this.userContactForm.value;
        this.emitUserContactForm.emit(
            userContact
        );
        return userContact;
    }

    populateUserContactForm(userContact?: any) {
        this.userContactForm = new FormGroup({
            companyName: new FormControl(userContact?.companyName ? userContact?.companyName : '', [Validators.required]),
            emailId: new FormControl(userContact?.emailId ? userContact?.emailId : '', [Validators.required, Validators.email]),
            phoneNumber: new FormControl(userContact?.phoneNumber ? userContact?.phoneNumber : ''),
            faxNumber: new FormControl(userContact?.faxNumber ? userContact?.faxNumber : ''),
            address: new FormControl(userContact?.address ? userContact?.address : '', [Validators.required]),
            city: new FormControl(userContact?.city ? userContact?.city : ''),
            state: new FormControl(userContact?.state ? userContact?.state : ''),
            country: new FormControl(userContact?.country ? userContact?.country : '', [Validators.required]),
            zipCode: new FormControl(userContact?.zipCode ? userContact?.zipCode : ''),
            domainName: new FormControl(userContact?.domainName ? userContact?.domainName : ''),
            role: new FormControl(userContact?.role ? userContact?.role : ''),
            userContactId: new FormControl(userContact?.userContactId ? userContact?.userContactId : ''),
            userId: new FormControl(userContact?.userId ? userContact?.userId : ''),
            partyType: new FormControl(userContact?.partyType)
        });
    }

}
